import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { CloseFooter } from '@/dialogs/common/closeFooter'
import { BsrsGrid, NameColumn } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'

function OutputReportInstitutionsDialog (props) {
  const { institutions } = props
  const { localize, locale } = useLocalization()

  const institutionType = ({ dataItem }) => {
    if (dataItem.InstitutionType === 1) {
      return <td>{localize('Enums:AssociationTypes_1')}</td>
    } else {
      return <td>{localize('Enums:AssociationTypes_2')}</td>
    }
  }

  return <React.Fragment><BasicHeader title='Institutions.Institution' {...props} />
    <ModalBody {...props}>
      <BsrsGrid items={institutions} disableExcelExport>
        {NameColumn({ locale, nameProp: 'name', latinNameProp: 'latinName', title: localize('Common.Name'), editable: false })}
        <Column field='code' title={localize('Common.Code')} />
        <Column cell={institutionType} title={localize('Common.Type')} />
      </BsrsGrid>
    </ModalBody>
    <CloseFooter btnColor='secondary' {...props} />
  </React.Fragment>
}

export default {
  modalProps: {
    className: 'modal-dialog--lg'
  },
  component: OutputReportInstitutionsDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/outputReportInstitutions.js